import { IKnol, Knol } from "@models/knol";
import cardPriority from "./cardPriority";
import { Grade } from "./grade";

export function newCards(cards: IKnol[]): IKnol[] {
  return cards.filter((card) => Grade(cardPriority(Knol.GetGrade(card))) === "NEW");
}
